import { lazy } from 'react'

export const GainWeightPeriod = lazy(() => import('./GainWeightPeriod'))
